import { Injectable } from '@angular/core';

@Injectable()
export abstract class UtilityService {

    public abstract isSurfaceDevice(): boolean;
}
